import type { ReactNode } from 'react';
import FloatingParticles from './FloatingParticles';

interface EmptyStateProps {
  illustration?: ReactNode;
  title?: string;
  children: ReactNode;
}

export default function EmptyState({ illustration, title, children }: EmptyStateProps) {
  return (
    <div className="section-empty">
      <FloatingParticles count={4} rise={140} />
      {illustration}
      {title && <h3 style={{ fontSize: 14, fontWeight: 700, color: 'var(--t1)', marginBottom: 6 }}>{title}</h3>}
      <p>{children}</p>
    </div>
  );
}
